export default __webpack_public_path__ + "static/media/me.e147a81e.jpg";